/**
 * DescriptionWrapper
 */
import clsx from 'clsx';
import React from 'react';
/** Main description for this component. */
var DescriptionWrapper = function (_a) {
    var lineBreak = _a.lineBreak, children = _a.children;
    return (React.createElement("div", { className: clsx(!lineBreak && 'md:flex md:flex-row', 'block mb-8') }, children));
};
export default DescriptionWrapper;
